<modal>
  <span header class="uppercase">{{'Xác nhận bổ xung mặt hàng' | lang}}</span>

  <table responsive class="data">
    <tr>
      <th class="text-right" style="width: 0">STT</th>
      <th>Mã hàng</th>
      <th class="text-left">Mã màu</th>
      <th class="text-right">Tỷ lệ lợi nhuận</th>
      <th class="text-right">Phí vận chuyển</th>
    </tr>
    <tr *ngFor="let i of products; index as ix">
      <td><small>{{ix + 1}}</small></td>
      <td><good class="bold text-primary spacy uppercase nowrap" [sku]="i.sku"></good></td>
      <td class="nowrap"><span *ngFor="let color of i.colors" class="text-warning bold color">{{color}}</span></td>
      <td>{{i.profit * 100 | number : '1.0-0' : 'en-US'}}<unit>%</unit></td>
      <td>{{i.logistics | number : '1.1-1' : 'en-US'}}<cny-per-m></cny-per-m></td>
    </tr>
    <tr>
      <td [colSpan]="6">
        <div class="flex w-100 space-between">
          <button class="bg-danger text-white hlf-margin-right w-100 text-center" (click)="confirm()"><span>{{'Tạo mới' | lang}}</span></button>
          <button class="bg-success text-white w-100 text-center" (click)="cancel()"><span>{{'Quay lại' | lang}}</span></button>
        </div>
      </td>
    </tr>
  </table>
</modal>
